import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\DossierNumbering\CreateDossierNumberingController::__invoke
* @see app/Http/Controllers/DossierNumbering/CreateDossierNumberingController.php
* @route '/api/dossier-numbering'
*/
const CreateDossierNumberingController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateDossierNumberingController.url(options),
    method: 'post',
})

CreateDossierNumberingController.definition = {
    methods: ["post"],
    url: '/api/dossier-numbering',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\DossierNumbering\CreateDossierNumberingController::__invoke
* @see app/Http/Controllers/DossierNumbering/CreateDossierNumberingController.php
* @route '/api/dossier-numbering'
*/
CreateDossierNumberingController.url = (options?: RouteQueryOptions) => {
    return CreateDossierNumberingController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\DossierNumbering\CreateDossierNumberingController::__invoke
* @see app/Http/Controllers/DossierNumbering/CreateDossierNumberingController.php
* @route '/api/dossier-numbering'
*/
CreateDossierNumberingController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateDossierNumberingController.url(options),
    method: 'post',
})

export default CreateDossierNumberingController